import { prepareHeaders } from "./";
import cincolabdataEndpoints from "./cincolabdata.endpoints";

interface SubmitAnswerValues {
  instance_key: string;
  email: string;
  field_key: string;
  value: string;
}

/**
 * Submits an answer to the API
 * @returns Returns a promise that resolves when the answer has been submitted
 */
export const submitAnswer = async ({
  instance_key,
  email,
  field_key,
  value,
}: SubmitAnswerValues): Promise<boolean> => {
  try {
    const response = await fetch(cincolabdataEndpoints.public.answer, {
      method: "POST",
      headers: prepareHeaders(),
      mode: "cors",
      body: JSON.stringify({
        instance_key,
        email: email.toLowerCase().trim(),
        field_key,
        value,
      }),
      redirect: "follow",
    });

    if (response.status !== 200) {
      throw new Error("Failed to submit answer");
    }
    return true;
  } catch (error) {
    console.error("SubmitAnswer: Fetch error details:", error);
    throw new Error(
      `SubmitAnswer: Failed to submit answer. ${(error as Error).message}`,
    );
  }
};
